<template lang="pug">
    div#app
        router-view.full-container
</template>
<script>
export default {
    name: 'App',
    created() {
        // 加载默认主题
        window.document.documentElement.setAttribute('data-theme', 'theme__1');
    },
};
</script>
<style lang="scss" src="./assets/styles/index.scss"></style>
